export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/fiction.3ea3b70.svg";